//This is tax-exemption-pdf.js
document.addEventListener('DOMContentLoaded', function() {
  // Only proceed if user is logged in and on tax exemption page 
  if (!document.getElementById('tax-exemption-app')) return;
  
  // Set up tax form option buttons
  const texasBtn = document.getElementById('texas-option-btn');
  const generalBtn = document.getElementById('general-option-btn');
  const texasForm = document.getElementById('texas-form');
  const generalForm = document.getElementById('general-form');
  
  texasBtn.addEventListener('click', function() {
    texasBtn.classList.add('selected');
    generalBtn.classList.remove('selected');
    texasForm.style.display = 'block';
    generalForm.style.display = 'none';
    
    // Update form requirements
    document.querySelectorAll('#texas-form input, #texas-form textarea, #texas-form select').forEach(el => {
      el.setAttribute('required', 'required');
    });
    document.querySelectorAll('#general-form input, #general-form textarea, #general-form select').forEach(el => {
      if (el.id !== 'other-reason') el.removeAttribute('required');
    });
  });
  
  generalBtn.addEventListener('click', function() {
    generalBtn.classList.add('selected');
    texasBtn.classList.remove('selected');
    generalForm.style.display = 'block';
    texasForm.style.display = 'none';
    
    // Update form requirements
    document.querySelectorAll('#general-form input, #general-form textarea, #general-form select').forEach(el => {
      if (el.id !== 'other-reason') el.setAttribute('required', 'required');
    });
    document.querySelectorAll('#texas-form input, #texas-form textarea, #texas-form select').forEach(el => {
      el.removeAttribute('required');
    });
  });
  
  // Handle exemption reason selection
  const exemptionReason = document.getElementById('exemption-reason');
  const otherReasonField = document.getElementById('other-reason-field');
  
  if (exemptionReason) {
    exemptionReason.addEventListener('change', function() {
      if (this.value === 'other') {
        otherReasonField.style.display = 'block';
        document.getElementById('other-reason').setAttribute('required', 'required');
      } else {
        otherReasonField.style.display = 'none';
        document.getElementById('other-reason').removeAttribute('required');
      }
    });
  }
  
  // Set up form submission
  const submitButton = document.getElementById('submit-tax-form');
  if (submitButton) {
    submitButton.addEventListener('click', function() {
      // Basic validation
      let formValid = true;
      const activeForm = texasBtn.classList.contains('selected') ? texasForm : generalForm;
      
      activeForm.querySelectorAll('[required]').forEach(el => {
        if (!el.value.trim()) {
          el.classList.add('error');
          formValid = false;
        } else {
          el.classList.remove('error');
        }
      });
      
      if (!document.getElementById('signature-name').value.trim()) {
        document.getElementById('signature-name').classList.add('error');
        formValid = false;
      }
      
      if (!document.getElementById('signature-date').value) {
        document.getElementById('signature-date').classList.add('error');
        formValid = false;
      }
      
      if (!formValid) {
        alert('Please fill out all required fields.');
        return;
      }
      
      // Collect form data
      const formData = {
        certificate_type: texasBtn.classList.contains('selected') ? 'texas' : 'general'
      };
      
      if (formData.certificate_type === 'texas') {
        formData.permit_number = document.getElementById('texas-permit-number').value;
        formData.business_activity = document.getElementById('texas-business-activity').value;
        formData.items_purchased = document.getElementById('texas-items').value;
      } else {
        formData.exemption_reason = document.getElementById('exemption-reason').value;
        if (formData.exemption_reason === 'other') {
          formData.other_reason = document.getElementById('other-reason').value;
        }
        formData.exemption_items = document.getElementById('exemption-items').value;
      }
      
      formData.signature = document.getElementById('signature-name').value;
      formData.signature_date = document.getElementById('signature-date').value;
      
      // Create a form to submit data to Shopify's contact form endpoint
      const form = document.createElement('form');
      form.method = 'post';
      form.action = '/contact';
      form.style.display = 'none';
      
      const emailInput = document.createElement('input');
      emailInput.type = 'hidden';
      emailInput.name = 'contact[email]';
      emailInput.value = Shopify.customer.email;
      
      const bodyInput = document.createElement('input');
      bodyInput.type = 'hidden';
      bodyInput.name = 'contact[body]';
      bodyInput.value = 'TAX_EXEMPTION_DATA:' + JSON.stringify(formData);
      
      const formTypeInput = document.createElement('input');
      formTypeInput.type = 'hidden';
      formTypeInput.name = 'form_type';
      formTypeInput.value = 'contact';
      
      const utf8Input = document.createElement('input');
      utf8Input.type = 'hidden';
      utf8Input.name = 'utf8';
      utf8Input.value = '✓';
      
      form.appendChild(emailInput);
      form.appendChild(bodyInput);
      form.appendChild(formTypeInput);
      form.appendChild(utf8Input);
      
      document.body.appendChild(form);
      
      // Show message and submit form
      document.getElementById('tax-exemption-app').style.display = 'none';
      document.getElementById('success-message').style.display = 'block';
      
      // Submit the form with a slight delay to allow the success message to display
      setTimeout(function() {
        form.submit();
      }, 500);
    });
  }
  
  // If user tries to leave with unsaved data
  window.addEventListener('beforeunload', function(e) {
    if (!submitButton) return;
    
    const activeForm = texasBtn.classList.contains('selected') ? texasForm : generalForm;
    let formStarted = false;
    
    activeForm.querySelectorAll('input, textarea, select').forEach(el => {
      if (el.value && el.type !== 'checkbox') {
        formStarted = true;
      }
    });
    
    if (document.getElementById('signature-name').value || document.getElementById('signature-date').value) {
      formStarted = true;
    }
    
    if (formStarted && document.getElementById('success-message').style.display !== 'block') {
      e.preventDefault();
      e.returnValue = 'You have unsaved tax exemption information. Are you sure you want to leave?';
      return e.returnValue;
    }
  });
});

function generateTaxCertificatePDF(data) {
  // Ensure jsPDF is loaded
  if (typeof jspdf === 'undefined') {
    // Load jsPDF library if not already present
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
    document.body.appendChild(script);
    
    script.onload = function() {
      createPDF(data);
    };
  } else {
    createPDF(data);
  }
  
  function createPDF(data) {
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF();
    
    // Set up the document
    doc.setFontSize(20);
    doc.text('Tax Exemption Certificate', 105, 30, { align: 'center' });
    
    doc.setFontSize(16);
    if (data.certificate_type === 'texas') {
      doc.text('Texas Sales and Use Tax Resale Certificate', 105, 40, { align: 'center' });
      
      doc.setFontSize(10);
      doc.text('Business Name:', 20, 60);
      doc.text(Shopify.customer.first_name + ' ' + Shopify.customer.last_name, 80, 60);
      
      doc.text('Tax Permit Number:', 20, 70);
      doc.text(data.permit_number, 80, 70);
      
      doc.text('Business Activity:', 20, 80);
      doc.text(data.business_activity, 80, 80, { maxWidth: 100 });
      
      doc.text('Items to be Purchased:', 20, 100);
      doc.text(data.items_purchased, 80, 100, { maxWidth: 100 });
      
      doc.text('I understand that it is a criminal offense to give a resale certificate to the seller for', 20, 120);
      doc.text('taxable items that I know, at the time of purchase, are purchased for use rather than for', 20, 125);
      doc.text('the purpose of resale, lease, or rental.', 20, 130);
    } else {
      doc.text('General Tax Exemption Certificate', 105, 40, { align: 'center' });
      
      doc.setFontSize(10);
      doc.text('Business Name:', 20, 60);
      doc.text(Shopify.customer.first_name + ' ' + Shopify.customer.last_name, 80, 60);
      
      doc.text('Exemption Reason:', 20, 70);
      doc.text(data.exemption_reason, 80, 70);
      
      if (data.exemption_reason === 'other' && data.other_reason) {
        doc.text('Other Reason Specified:', 20, 80);
        doc.text(data.other_reason, 80, 80);
      }
      
      doc.text('Items to be Purchased:', 20, 90);
      doc.text(data.exemption_items, 80, 90, { maxWidth: 100 });
      
      doc.text('I understand that I will be liable for payment of all state and local sales or use taxes', 20, 110);
      doc.text('which may become due for failure to comply with the provisions of the Tax Code and/or', 20, 115);
      doc.text('all applicable law.', 20, 120);
    }
    
    doc.text('Digital Signature:', 20, 140);
    doc.text(data.signature, 80, 140);
    
    doc.text('Date:', 20, 150);
    doc.text(data.signature_date, 80, 150);
    
    // Save the PDF
    doc.save('tax_exemption_certificate.pdf');
  }
}